// extracted by mini-css-extract-plugin
export var searchHeader = "_1v-0";
export var searchHeaderDark = "_1v-1";